import { useMembership } from '~/techstyle-shared/react-accounts';

export default function useMembershipLevelGroup() {
  const { isLead, isVip, isElite } = useMembership();

  if (isElite) {
    return 'elite';
  }

  if (isVip) {
    return 'vip';
  }

  if (isLead) {
    return 'lead';
  }

  return 'visitor';
}
